import React, { useEffect, useState, useRef } from "react";
import "../componentsStyle/home.css"
import styles from "../componentsStyle/home.module.css";
import totalLocationData from "../../data/locationdata";
import { getFetch } from "../../fetch/fetch";
import { AcUnit, Brightness7, SentimentSatisfied } from "@mui/icons-material";

const standard = {
    min: 20,
    max: 24
}

const Temperature: React.FC<any> = (props: any) => {

    const [data, setData] = useState<any>([]);

    const getTempuerature = async () => {
        try {
            console.log("온도 가져오기");
            // API 호출 로직

            const result: any = await getFetch("/dashboard/iot/thermohygrometer");

            console.log("온도 데이터:", result);

            const data = result.data;

            //좌석번호 오름차순 정렬
            data.sort((a: any, b: any) => {
                return a.seatNumber[0] - b.seatNumber[0];
            });

            //각 seatNumber 안에서 오름차순 정렬
            data.forEach((eachDataItem: any) => {
                eachDataItem.seatNumber.sort((a: number, b: number) => {
                    return a - b;
                });
            });

            if (result.message === "success") {
                setData([...data]);
            }

        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        // 처음 화면 진입 시 1번 실행
        getTempuerature();

        // 5분마다 실행 (5 * 60 * 1000 ms)
        const interval = setInterval(() => {
            getTempuerature();
        }, 1 * 60 * 1000);

        // 화면에서 사라질 때 interval 정리
        return () => {
            clearInterval(interval);
        };
    }, []); // 빈 배열 → 컴

    const getTemperatureStatus = (temperature: number) => {
        if (temperature < standard.min) {
            return "cold";
        }
        if (temperature > standard.max) {
            return "hot";
        }
        return "good";
    };




    return (
        <div>
            <div style={{
                display: "flex",
                //줄 바꿈 허용
                flexWrap: "wrap",
                //가운데 정렬
                //간격 띄우기
                gap: "40px",
            }}>
                {
                    props.user && totalLocationData.map((eachLocation, index) => {


                        if (eachLocation.english === "total") {
                            return;
                        }

                        if (!eachLocation.academy.includes(props.user.academy) && eachLocation.english !== "bundang") {
                            return;
                        }


                        return (
                            <div className={styles.attendanceBoardWeek2} style={{
                                height: "180px",
                            }}>
                                <div className={styles.attendanceBoardTitle}>
                                    <div className={styles.attendanceBoardTitle_1}>
                                        {eachLocation.korean}
                                    </div>
                                    {/* <div onClick={(e: any) => { }} className={styles.attendanceBoardTitle_2}>
                        #자세히
                    </div> */}
                                </div>
                                <div className={styles.attendanceBoardDescription} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "110px",
                                }}>
                                    {
                                        data.map((eachDataItem: any, dataIndex: number) => {

                                            const location = eachDataItem.location;

                                            if (eachLocation.english !== location) {
                                                return;
                                            }

                                            const status = getTemperatureStatus(+eachDataItem.temperature);

                                            return (
                                                <div key={dataIndex} style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width : "72px"
                                                }}>
                                                    <div style={{
                                                        marginBottom: "8px",
                                                        fontFamily: "Apple_B",

                                                    }}>
                                                        {
                                                            eachDataItem.seatNumber.length === 1
                                                            ?
                                                                `${eachDataItem.seatNumber[0]}`
                                                            :
                                                                `${eachDataItem.seatNumber[0]}-${eachDataItem.seatNumber[eachDataItem.seatNumber.length - 1]}`
                                                            
                                                        }
                                                    </div>
                                                    <div style={{
                                                        marginBottom: "2px",
                                                    }}>
                                                        {status === "cold" && (
                                                            <AcUnit fontSize="large" color="primary" />
                                                        )}

                                                        {status === "good" && (
                                                            <SentimentSatisfied fontSize="large" color="success" />
                                                        )}

                                                        {status === "hot" && (
                                                            <Brightness7 fontSize="large" color="error" />
                                                        )}
                                                    </div>
                                                    <div
                                                        style={{
                                                            color:
                                                                status === "cold"
                                                                    ? "#1976d2"
                                                                    : status === "hot"
                                                                        ? "#d32f2f"
                                                                        : "#2e7d32",
                                                            fontWeight: "bold",
                                                        }}
                                                    >
                                                        {eachDataItem.temperature}℃
                                                    </div>
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default Temperature;
